import React, { useState, useEffect } from 'react'
import styled from '@emotion/styled'
import { Link } from '@reach/router'
import useCallbackStatus from 'hooks/useCallbackStatus'
import { StringParam, useQueryParams } from 'use-query-params'
import { Form } from 'antd'
import { StyledAlert } from 'components'
import {
	StyledPreLoginForm,
	PreLoginView,
	StyledPreLoginAlert,
	PreLoginTitle,
	PreLoginSubTitle,
	PreLoginInput,

	PreLoginInputPassword,
	PreLoginButton,
	PreLoginViewFooter
} from 'views/PreLogin/styled'
import useAxios from 'axios-hooks'
import { UtesterLogo, User1stLogo } from '../Logos';

const SignUpForm = styled.div({
	marginTop: 20
})

const PASSWORD = 'password'
const NAME = 'first_name'
const SURNAME = 'last_name'

function UserSignUp({ form, navigate }) {
    const { isPending, error, run } = useCallbackStatus()
	const { getFieldDecorator } = form
	const [token] = useQueryParams({
		token: StringParam
    })
    

    const [
		{ data: signUpResponse, loading: signUpLoading, error: signUpError, response },
		submitSignUpRequest
	] = useAxios(
		{
			url: `/account/signup-user`,
			method: 'POST'
		},
		{ manual: true }
	)
    const handleSubmit = event => {
		event.preventDefault()
		form.validateFields([NAME,SURNAME,PASSWORD], (errors, values) => {
			const { first_name, last_name, password } = values
			
			if (!errors) {
				submitSignUpRequest({ data: { name: first_name, surname: last_name, password, token: token.token} })
			}
		})
    }
    
    const errorMessage =
        signUpError &&
        signUpError.response &&
        signUpError.response.data &&
        (signUpError.response.data.message || signUpError.response.data.Errors)
    
    response 
        && response.status == 200
        && navigate('/sign-in')
    return (
        <PreLoginView>
            <StyledPreLoginForm>
				<UtesterLogo />
                {errorMessage && (
					<StyledPreLoginAlert>
						<StyledAlert showIcon type="error" message="Error" description={errorMessage} radius={4} />
					</StyledPreLoginAlert>
				)}
                <PreLoginTitle>Sign Up</PreLoginTitle>
				<PreLoginSubTitle>Fill form down below to create new user</PreLoginSubTitle>
                <SignUpForm>
                    <Form onSubmit={handleSubmit} layout="vertical">
                    
                    <Form.Item>
						{getFieldDecorator(NAME, {
							validateTrigger: ['onChange', 'onBlur'],
							rules: [
								{
									required: true,
									whitespace: true,
									message: 'Name is Required'
								}
							]
						})(<PreLoginInput placeholder="NAME" />)}
					</Form.Item>

					<Form.Item>
						{getFieldDecorator(SURNAME, {
							validateTrigger: ['onChange', 'onBlur'],
							rules: [
								{
									required: true,
									whitespace: true,
									message: 'Surname is Required'
								}
							]
						})(<PreLoginInput placeholder="SURNAME" />)}
					</Form.Item>

                    <Form.Item>
							{getFieldDecorator(PASSWORD, {
								validateTrigger: ['onChange', 'onBlur'],
								rules: [
									{
										required: true,
										message: 'Password is Required'
									}
								]
							})(<PreLoginInputPassword type="password" placeholder="PASSWORD" />)}
						</Form.Item>

                        <PreLoginButton size="large" type="primary" htmlType="submit" loading={isPending}>
							SIGN UP
						</PreLoginButton>
                    </Form>
                </SignUpForm>
            </StyledPreLoginForm>
			<User1stLogo />
        </PreLoginView>
    )
}

export default Form.create({})(UserSignUp)